import { Image } from '@vyce/core/src/types';

export const getArrayOfNewDocs = (photos: Image[]) => photos.filter(item => item.file);
